/* fuga-scroll.js — Lenis smooth-scroll. Pauses while the cart/wishlist drawer is open and
   lets drawers scroll natively, so the drawer's scroll-lock doesn't jump the page to top. */
(function () {
  if (!window.Lenis) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = 'html.lenis,html.lenis body{height:auto}'
    + '.lenis.lenis-smooth{scroll-behavior:auto!important}'
    + '.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}'
    + '.lenis.lenis-stopped{overflow:hidden}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true });
  function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);
  window.__fugaLenis = lenis;

  /* Drawer integration: native scroll inside drawers + pause Lenis while a drawer is open. */
  function markPrevent() {
    document.querySelectorAll('[data-fuga-cart-body],[data-fuga-wish-list],[data-fuga-wish-drawer]').forEach(function (el) {
      if (!el.hasAttribute('data-lenis-prevent')) el.setAttribute('data-lenis-prevent', '');
    });
  }
  markPrevent();
  function sync() {
    var open = document.body.classList.contains('fuga-cart-open') || document.body.classList.contains('fuga-wish-open');
    if (open) lenis.stop(); else lenis.start();
  }
  new MutationObserver(function () { sync(); markPrevent(); })
    .observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
